import React, { useEffect, useMemo, useState } from "react"
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import { Accordion } from 'react-bootstrap'
import { ColumnMedalEvent, ColumnMedalEventWithCompetitor, ColumnMedalCompetitor, ColumnMedal, ColumnDisciplineMobile, ColumnMedalNoc, ColumnMedalDiscipline } from "components/common/schedule/TableColumns"
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import { getLevelRSC, getLongEventRSC } from "helpers/rsc"
import Noc from "components/presentation/Noc";

const getConfiguration = ({ breakPoint, isAlphabeticalSort = true }) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = [{ id: 'Discipline', desc: false }, { id: 'Event', desc: false }, { id: 'Medal', desc: false }, { id: 'NOC', desc: false }, { id: 'Competitor', desc: false }];
  configuration.columns = isMobile ? TableColumnsSM({ isAlphabeticalSort }) : TableColumns({ isAlphabeticalSort })
  return configuration;
};


const MedallistsTable = ({ data }) => {
  const { breakPoint } = useViewport();
  const [isAlphabeticalSort, setIsAlphabeticalSort] = useState(true)
  const config = useMemo(() => getConfiguration({ breakPoint, isAlphabeticalSort }), [breakPoint, isAlphabeticalSort]);
  const [paramsUrl, setParamsUrl] = useState({});
  const [shouldNavigate, setShouldNavigate] = useState(false);
  useNavigateTo(paramsUrl, shouldNavigate, setShouldNavigate, 'results')
  useEffect(() => {
    const isAlphabetical = !(data?.some(item => item?.discipline?.descriptionOrder && item?.discipline?.descriptionOrder !== 0));
    setIsAlphabeticalSort(isAlphabetical);
    data.sort((a, b) => {
      const disciplineSort = isAlphabeticalSort ? a?.discipline?.description?.toLowerCase().localeCompare(b?.discipline?.description?.toLowerCase()) : a?.discipline?.descriptionOrder - b?.discipline?.descriptionOrder;
      const eventSort = a?.event?.order - b.event?.order;
      const medalSort = a?.medal_type - b?.medal_type;
      const nocSort = a?.participant?.organisation?.descriptionOrder - b?.participant?.organisation?.descriptionOrder;
      const competitorNameSort = a?.participant?.name?.toUpperCase().localeCompare(b?.participant?.name?.toUpperCase());

      return disciplineSort || eventSort || medalSort || nocSort || competitorNameSort;
    });
  }, [data, isAlphabeticalSort]);
  //Prepare URL to navigate
  const params = useUrlFriendlyToParameters()
  let paramsURL = { ...params }

  const handleClick = (props) => {
    const rsc = props?.eventUnit?.code;
    if (getLevelRSC(paramsURL["mirs_rsc"]) === "EVENT") {
      paramsURL["mirs_event_rsc"] = rsc
      paramsURL["mirs_rsc"] = undefined
    } else {
      //Phase or unit
      paramsURL["mirs_event_rsc"] = getLongEventRSC(rsc)
      paramsURL["mirs_rsc"] = rsc
    }
    setParamsUrl(paramsURL);
  };

  return (
    <MirsTable
      className="table-schedule"
      data={data}
      columns={config.columns}
      keyRow='participant-athleteEventCode'
      initialSortBy={config.sortBy}
      rowOnClick={true}
      rowClickHandler={handleClick}
      id={`mirs-table-medallists`}
      showPagination={true}
    // pageSizeCustom={10}
    />
  )
}

export default MedallistsTable;



function TableColumns({ isAlphabeticalSort = true }) {
  return (
    [
      ColumnMedalNoc({ label: "HeaderTeamNOC", headerClassName: "text-start w-10", disableSort: true }),
      ColumnMedalCompetitor({ disableSort: false }),
      ColumnMedalDiscipline({ label: "HeaderSport", disableSort: false, showDesc: true, isAlphabeticalSort }),
      ColumnMedalEvent({ disableSort: true }),
      ColumnMedal({}),
      //ColumnDate(globalProps, { disableSort: false })
    ]
  )
}
function TableColumnsSM({ isAlphabeticalSort = true }) {
  return (
    [
      ColumnMedalEventWithCompetitor({ hidePicture: false }),
      ColumnMedalDiscipline({ label: "HeaderSport", disableSort: false, showDesc: true, isAlphabeticalSort }),
      ColumnMedal({}),
    ]
  )
}


